import React from 'react';
import { usePageTracking, useClickTracking } from '../hooks/useTracking';

interface TrackingProviderProps {
  children: React.ReactNode;
  enablePageTracking?: boolean;
  enableClickTracking?: boolean;
}

// Componente provider que activa el tracking automático
const TrackingProvider: React.FC<TrackingProviderProps> = ({
  children,
  enablePageTracking = false, // Desactivar por defecto para evitar spam
  enableClickTracking = false, // Desactivar por defecto para evitar spam
}) => {
  // Siempre llamar los hooks, pero con lógica condicional interna
  usePageTracking(enablePageTracking);
  useClickTracking(enableClickTracking);

  return <>{children}</>;
};

export default TrackingProvider;

